import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../../../assets/css/Work/projects.css"
import { Container } from "reactstrap"
import DedicatedProject from "./DedicatedProject"

const ProjectIndex = () => {
  document.title = "Dedicated Projects | Zithas Crm"

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>

          <Breadcrumbs title="Projects" breadcrumbItem="Dedicated Resources" />

          <div className="card h-100 p-3 mt-3">
            <DedicatedProject projectType="2" />
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default ProjectIndex
